import React, { useContext } from 'react'
import { PlayerProfileContext } from '../../Context'
import { PageHeader } from '../../Components/Headers'
import { PageContainerMain, Box, BottomAppCallout } from '../../Components/Layout'
import { PlayerLinkBar } from './components'
import { MediaTab } from './MediaTab'
import { createPlayerDynamicLink } from '../../Utils'
import { AutocompleteContainer } from '../../Components/Search'
import { AdUnit } from '../../Components/Ads/AdUnit'

const PlayerMedia: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { player, urls } = useContext(PlayerProfileContext)!

  return (
    <PageContainerMain>
      {urls?.teamBanner && <PageHeader img={urls.teamBanner} />}
      <AutocompleteContainer />
      <AdUnit bannerType="bannerMain" aria-label="Player media page ad" />
      <Box>
        <PlayerLinkBar />
      </Box>
      <MediaTab />
      {player?.slug && (
        <BottomAppCallout
          text={`View ${player.lastName}'s news in the PLL App`}
          appLink={createPlayerDynamicLink(player, 'profile', true)}
          location={`${player.slug}_stats_page`}
        />
      )}
    </PageContainerMain>
  )
}

export default PlayerMedia
